declare const ENV_VARS_AS_JSON: any;

let ResolveEnvVars = () =>
{
    let returnValue: any = {};

    try
    {
        if (typeof ENV_VARS_AS_JSON !== "undefined" && ENV_VARS_AS_JSON)
            returnValue = JSON.parse(ENV_VARS_AS_JSON ?? "{}");
        else
        {
            console.error(
                '$$$> ' +
                'ENV_VARS_AS_JSON is not defined' + '\n' +
                'ENV_VARS_AS_JSON = ', typeof ENV_VARS_AS_JSON !== "undefined" ? ENV_VARS_AS_JSON : undefined, '\n' +
            '');

        }
    }
    catch (error)
    {
        console.error(
            '$$$> ' +
            'Failed to parse ENV_VARS_AS_JSON',
            error,
        );
    }

    return returnValue;
}

export const GetEnvVars = () =>
{
    return ENV_VARS;
}

// const ENV_VARS = JSON.parse(ENV_VARS_AS_JSON);
const ENV_VARS = ResolveEnvVars();
const process: any = { env: ENV_VARS, };
